import type { READABLE_MDF_FIELDS_QUERY_PARAMETER } from '@mimir/common/dto/itemModelPrimitives';
import type { SearchResult } from '@mimir/common/search/interfaces';
import type { BackendClient } from '@mimir/common/util/backendClient';
import type { HttpQueryParameters } from '@mimir/common/util/apiClient';
import { callApiCommand } from '../api/callApiCommand';
import { SearchCommand } from '@mimir/common/api/searchCommands';

export interface SearchProps {
  timeZone?: string;
  itemsPerPage: number;
  includeSubfolders?: boolean;
  from?: number;
  searchString: string;
  isFuzzy?: boolean;
  atSameTime?: boolean;
  folderId?: string;
  folderName?: string;
  includeFolders?: boolean;
  showOnlyDeletedItems?: any; //TODO some type safety issues with this one
  sortProperty?: string;
  sortOrder?: string;
  isCustomSortProperty?: boolean;
  sortParamsList?: string;
  includeTypeCounts?: boolean;
  includeDateCounts?: boolean;
  defaultDateRangeField?: string;
  excludeFields?: string[];
  useCustomSearchHook?: boolean;
  [READABLE_MDF_FIELDS_QUERY_PARAMETER]?: boolean;
}

/**
 * Responsible for sanitising the search params before sending a search to the server
 */
export function buildSearchParams(props: SearchProps, fieldProps?: Record<string, string[]>): HttpQueryParameters {
  const { itemsPerPage, from, folderId, folderName } = props;
  const finalQueryParams: HttpQueryParameters = {...props, ...fieldProps};

  finalQueryParams.from = from && from > 0 ? from : 0;
  if (itemsPerPage > 0) {
    finalQueryParams.itemsPerPage = itemsPerPage;
  }
  if (folderId && folderName) {
    finalQueryParams.folderId = folderId;
  }
  return finalQueryParams;
}

type SearchScrollStartParamsType = (HttpQueryParameters & { scroll: true, fetchFatVersion?: boolean, fetchFullVersion?: boolean });

export type SearchScrollParamsType = SearchScrollStartParamsType | { mScrollId: string, fetchFatVersion?: boolean, fetchFullVersion?: boolean };

export async function getSearchResult(client: BackendClient, queryParams: HttpQueryParameters): Promise<SearchResult> {
  return await callApiCommand(client, new SearchCommand({ queryParams }), undefined);
}

export const AUTO_REFRESH_SEARCH_INTERVAL_IN_MS = 30 * 1000;
